var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('ul',{ref:"navSwiper",staticClass:"slide-items"},_vm._l((_vm.navList),function(item){return _c('li',{key:item.i,on:{"click":function($event){return _vm.handleClick($event, item)}}},[_c('p',{class:{'nav-active': _vm.currCid == item.name}},[_vm._v(_vm._s(item[_vm.language]))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-176cba4e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Nav.vue
// module id = null
// module chunks = 